'use client';

import { Button, ButtonProps } from '../Button';
import { cx } from '../cx';
import { Icon } from '../Icon';
import { useModalActions } from './context';

type ModalCloseButtonProps = Omit<ButtonProps, 'children' | 'onClick'>;

export function ModalCloseButton({
    className,
    ...props
}: ModalCloseButtonProps) {
    const { close } = useModalActions();

    return (
        <Button
            {...props}
            className={cx('p-2xs size-[32px] text-xl', className)}
            onClick={() => close()}
        >
            <Icon>close</Icon>
        </Button>
    );
}
